import React, { useEffect, useMemo } from 'react';

import { normalize, schema } from 'normalizr';
import PropTypes from 'prop-types';

import { Feedback, PillCheckbox, Spinner } from 'components';

const FormPillSelector = ({
  input,
  meta,
  loadingError,
  isLoading,
  options,
  readOnly,
  maxSelected,
  showSelectAll,
}) => {
  const { value, onChange } = input;

  const items = new schema.Entity('items');
  const normalized = normalize(value || [], [items]).entities;
  const valueIds = normalized.hasOwnProperty(items.key)
    ? Object.keys(normalized[items.key]).map(key => parseInt(key))
    : [];

  const onClick = option => event => {
    event.preventDefault();
    if (readOnly) return;

    if (valueIds.includes(option.id)) {
      onChange(value.filter(v => v.id !== option.id));
    } else if (!maxSelected || value.length < maxSelected) {
      onChange([option, ...value]);
    }
  };

  // Handle "Select All" toggle
 const handleSelectAllChange = event => {
  const currentValue = Array.isArray(value) ? value : [];

  if (event.target.checked) {
    const mergedOptions = [
      ...currentValue.filter(v => !options.some(opt => opt.id === v.id)),
      ...options,
    ];
    onChange(mergedOptions);
  } else {
    const remainingOptions = currentValue.filter(
      v => !options.some(opt => opt.id === v.id)
    );

    onChange(remainingOptions);
  }
};

  return (
    <>
      {isLoading ? (
        <Spinner show />
      ) : (
        <div>
          {showSelectAll && (
            <div className="d-flex align-items-center">
              <input
                id="selectAll"
                type="checkbox"
                onChange={handleSelectAllChange}
                checked={
                  options.length > 0 &&
                  options.every(opt => valueIds.includes(opt.id))
                }
                disabled={readOnly}
                aria-label="Select All"
              />
              <label htmlFor="selectAll" className="ml-1 mb-0">
                Select All
              </label>
            </div>
          )}
          {options.map(option => (
            <PillCheckbox
              key={option.id}
              text={option.name}
              checked={!!valueIds && valueIds.includes(option.id)}
              onClick={onClick(option)}
              type="checkbox"
            />
          ))}
        </div>
      )}
      <Feedback
        show={!!loadingError || ((meta.error || meta.submitError) && meta.touched)}
        content={loadingError || meta.error || meta.submitError}
        invalid
      />
    </>
  );
};

FormPillSelector.propTypes = {
  options: PropTypes.arrayOf(PropTypes.object),
  maxSelected: PropTypes.number,
  loadingError: PropTypes.string,
  isLoading: PropTypes.bool,
  input: PropTypes.object,
  meta: PropTypes.object,
  readOnly: PropTypes.bool,
  showSelectAll: PropTypes.bool,
};

export default FormPillSelector;
